import { combineReducers } from "redux";
import AssetOwnershipProfileModalReducer from "./AssetOwnershipProfileModalReducer";
import addCommentModalReducer from "./addCommentModalReducer";
import downloadReportModalReducer from "./downloadReportModalReducer";
import { analysisReducer } from "./analysisViewReducer";
import authoriseReducer from "./authoriseReducer";
import bankingCommentsModalReducer from "./bankingCommentsModalReducer";
import collectionBreakdownModalReducer from "./collectionBreakdownModalReducer";
import collectionModalReducer from "./collectionModalReducer";
import confirmModalReducer from "./confirmModalReducer";
import confirmInputModalReducer from "./confirmInputModalReducer";
import countDetailsModalReducer from "./countDetailsModalReducer";
import eftReducer from "./eftReducer";
import floatLevelSettingsModalReducer from "./floatLevelSettingsModalReducer";
import installHistoryModalReducer from "./installHistoryModalReducer";
import {
  addPositionsReducer,
  installationReducer,
  setActiveInstallationReducer,
} from "./installationReducer";
import kioskReducer from "./kioskReducer";
import liveFloorViewDetailsModalReducer from "./liveFloorViewDetailsModalReducer";
import { logInReducer } from "./logInOutReducer";
import machineReducer from "./machineReducer";
import machineSaveReducer from "./machineSaveReducer";
import newProfileModalReducer from "./newProfileModalReducer";
import operatorsReducer from "./operatorsReducer";
import {
  analysisFiltersReducer,
  collectionsFiltersReducer,
  complianceFiltersReducer,
  customerFiltersReducer,
  installationsFiltersReducer,
  kioskFiltersReducer,
  LiveFloorViewerFiltersReducer,
  sessionsFiltersReducer,
  settingsFiltersReducer,
  transactionsFiltersReducer,
} from "./organisationDirectoryReducer";
import organisationReducer from "./organisationReducer";
import organisationsReducer from "./organisationsReducer";
import passwordModalReducer from "./passwordModalReducer";
import promoAnalysisDetailsModalReducer from "./promoAnalysisDetailsModalReducer";
import promoAnalysisModalReducer from "./promoAnalysisModalReducer";
import removeAssetReducer from "./removeAssetReducer";
import revenueModalReducer from "./revenueModalReducer";
import searchTermReducer from "./searchTermReducer";
import sessionsByCompanyReducer from "./sessionsByCompanyReducer";
import siteDetailsModalReducer from "./siteDetailsModalReducer";
import siteVarianceHistoryModalReducer from "./siteVarianceHistoryModalReducer";
import successAlertReducer from "./successAlertReducer";
import {
  transactionAdjustReducer,
  transactionAuthoriseReducer,
  transactionsKioskReducer,
  transactionsLiabilityReducer,
  transactionsReducer,
  transactionsTicketsReducer,
  transactionsViewReducer,
  transactionVoidReducer,
} from "./transactionsReducer";
import varianceHistoryDetailsModalReducer from "./varianceHistoryDetailsModalReducer";
import viewCommentsModalReducer from "./viewCommentsModalReducer";
import EditMachineCountModalReducer from "./EditMachineCountModalReducer";
import { complianceSummaryTabReducer } from "./complianceSummaryReducer";
import ProcessPeriodModalReducer from "./ProcessPeriodModalReducer";
import LoginReducer from "@common/redux/reducers/LoginReducer";
import LoadingReducer from "@common/redux/reducers/LoadingReducer";
import CustomerIncidentReducer from "@common/redux/reducers/CustomerIncidentReducer";
import CustomerFormReducer from "@common/redux/reducers/CustomerFormReducer";
import OfficerReducer from "@common/redux/reducers/OfficerReducer";
import OfficerFormModalReducer from "@common/redux/reducers/OfficerFormModalReducer";
import AlertModalReducer from "@common/redux/reducers/AlertModalReducer";
import InteractionOptionsReducer from "@common/redux/reducers/InteractionOptionsReducer";
import CustomerInteractionReducer from "@common/redux/reducers/CustomerInteractionReducer";
import AgeVerificationReducer from "@common/redux/reducers/AgeVerificationReducer";
import ObservationsReducer from "@common/redux/reducers/ObservationsReducer";
import SetupReducer from "@common/redux/reducers/SetupReducer";
import LinkSessionReducer from "@common/redux/reducers/LinkSessionReducer";
import LinkAlertReducer from "@common/redux/reducers/LinkAlertReducer";
import SessionModalReducer from "@common/redux/reducers/SessionModalReducer";
import MachineSessionModalReducer from "@common/redux/reducers/MachineSessionModalReducer";
import SessionalDetailsReducer from "@common/redux/reducers/SessionalDetailsReducer";
import SessionalPositionsReducer from "@common/redux/reducers/SessionalPositionsReducer";
import UnresolvedDisputeReducer from "@common/redux/reducers/UnresolvedDisputeReducer";
import SuspiciousActvityReducer from "@common/redux/reducers/SuspiciousActivityReducer";
import EnforcementReducer from "@common/redux/reducers/EnforcementReducer";
import ConfirmModalReducer from "@common/redux/reducers/ConfirmModalReducer";
import ConfirmInputModalReducer from "@common/redux/reducers/ConfirmInputModalReducer";
import MergeCustomersModalReducer from "@common/redux/reducers/MergeCustomersModalReducer";
import UploadReducer from "@common/redux/reducers/UploadReducer";
import ImageModalReducer from "@common/redux/reducers/ImageModalReducer";
import QrCodeReducer from "@common/redux/reducers/QrCodeReducer";
import AgcCheckReducer from "@common/redux/reducers/AgcCheckReducer";
import CustomerReviewReducer from "@common/redux/reducers/CustomerReviewReducer";
import CustomerReviewModalReducer from "@common/redux/reducers/CustomerReviewModalReducer";
import ComplianceAlertsReducer from "@common/redux/reducers/ComplianceAlertsReducer";
import IdentityFormModalReducer from "@common/redux/reducers/IdentityFormModalReducer";
import PhotoReducer from "@common/redux/reducers/PhotoReducer";
import AuthorisationModalReducer from "@common/redux/reducers/AuthorisationModalReducer";
import CustomerReducer from "@common/redux/reducers/CustomerReducer";
import CustomerReviewFiltersReducer from "@common/redux/reducers/CustomerReviewFiltersReducer";
import {
  activeComplianceModule,
  complianceEvents,
  complianceMetadata,
  complianceModel,
  complianceRecords,
  complianceCustomerConfig,
  complianceAlertConfig,
  complianceAgeConfig,
  complianceCustomerInteractionConfig,
} from "./complianceReducer";
import revenueTermsProfilesReducer from "./revenueTermsProfilesReducer";
import { customerTabReducer } from "./customerTabReducer";
import siteAllocatedModalReducer from "./siteAllocatedModalReducer";
import mainMenuReducer from "./mainMenuReducer";
import createAssetModalReducer from "./createAssetModalReducer";
import frsClientSecretModalReducer from "./frsClientSecretModalReducer";
import frsClientSecretKeyModalReducer from "./frsClientSecretKeyModalReducer";

const appReducer = combineReducers({
  // modals
  addCommentModal: addCommentModalReducer,
  assetOwnershipProfileModal: AssetOwnershipProfileModalReducer,
  bankingCommentsModal: bankingCommentsModalReducer,
  collectionBreakdownModal: collectionBreakdownModalReducer,
  collectionModal: collectionModalReducer,
  confirmModal: confirmModalReducer,
  confirmInputModal: confirmInputModalReducer,
  countDetailsModal: countDetailsModalReducer,
  downloadReportModal: downloadReportModalReducer,
  editMachineCountModal: EditMachineCountModalReducer,
  floatLevelSettingsModal: floatLevelSettingsModalReducer,
  installHistoryModal: installHistoryModalReducer,
  newProfileModal: newProfileModalReducer,
  passwordModal: passwordModalReducer,
  processPeriodModal: ProcessPeriodModalReducer,
  promoAnalysisDetailsModal: promoAnalysisDetailsModalReducer,
  promoAnalysisModal: promoAnalysisModalReducer,
  revenueModal: revenueModalReducer,
  siteDetailsModal: siteDetailsModalReducer,
  siteVarianceHistoryModal: siteVarianceHistoryModalReducer,
  successAlert: successAlertReducer,
  varianceHistoryDetailsModal: varianceHistoryDetailsModalReducer,
  viewCommentsModal: viewCommentsModalReducer,
  siteAllocatedModal: siteAllocatedModalReducer,
  createAssetModal: createAssetModalReducer,
  frsClientSecretModal: frsClientSecretModalReducer,
  frsClientSecretKeyModal: frsClientSecretKeyModalReducer,

  // filters (for organisation directory)
  analysisFilters: analysisFiltersReducer,
  collectionsFilters: collectionsFiltersReducer,
  complianceFilters: complianceFiltersReducer,
  customerFilters: customerFiltersReducer,
  installationsFilters: installationsFiltersReducer,
  kioskFilters: kioskFiltersReducer,
  LiveFloorViewerFilters: LiveFloorViewerFiltersReducer,
  sessionsFilters: sessionsFiltersReducer,
  settingsFilters: settingsFiltersReducer,
  transactionsFilters: transactionsFiltersReducer,

  // other
  activeInstallation: setActiveInstallationReducer,
  analysisView: analysisReducer,
  assetRemove: removeAssetReducer,
  authorise: authoriseReducer,
  complianceSummaryTab: complianceSummaryTabReducer,
  customerTab: customerTabReducer,
  eftUpdate: eftReducer,
  installations: installationReducer,
  revenueTermsProfiles: revenueTermsProfilesReducer,
  kiosk: kioskReducer,
  liveFloorViewDetailsModal: liveFloorViewDetailsModalReducer,
  logIn: logInReducer,
  machine: machineReducer,
  machineSave: machineSaveReducer,
  operators: operatorsReducer,
  organisation: organisationReducer,
  organisations: organisationsReducer,
  positionsAdd: addPositionsReducer,
  searchTerms: searchTermReducer,
  sessionsByCompany: sessionsByCompanyReducer,
  transactionAdjust: transactionAdjustReducer,
  transactionAuthorise: transactionAuthoriseReducer,
  transactions: transactionsReducer,
  transactionsKiosk: transactionsKioskReducer,
  transactionsLiability: transactionsLiabilityReducer,
  transactionsTickets: transactionsTicketsReducer,
  transactionsView: transactionsViewReducer,
  transactionVoid: transactionVoidReducer,
  mainMenuState: mainMenuReducer,

  // common
  ...CustomerIncidentReducer.map(),
  ...CustomerFormReducer.map(),
  ...LoginReducer.map(),
  ...LoadingReducer.map(),
  ...OfficerReducer.map(),
  ...OfficerFormModalReducer.map(),
  ...AlertModalReducer.map(),
  ...InteractionOptionsReducer.map(),
  ...CustomerInteractionReducer.map(),
  ...AgeVerificationReducer.map(),
  ...ObservationsReducer.map(),
  ...SetupReducer.map(),
  ...LinkSessionReducer.map(),
  ...LinkAlertReducer.map(),
  ...SessionModalReducer.map(),
  ...MachineSessionModalReducer.map(),
  ...SessionalDetailsReducer.map(),
  ...SessionalPositionsReducer.map(),
  ...UnresolvedDisputeReducer.map(),
  ...SuspiciousActvityReducer.map(),
  ...EnforcementReducer.map(),
  ...ConfirmModalReducer.map(),
  ...ConfirmInputModalReducer.map(),
  ...MergeCustomersModalReducer.map(),
  ...UploadReducer.map(),
  ...ImageModalReducer.map(),
  ...QrCodeReducer.map(),
  ...AgcCheckReducer.map(),
  ...CustomerReviewReducer.map(),
  ...CustomerReviewModalReducer.map(),
  ...ComplianceAlertsReducer.map(),
  ...IdentityFormModalReducer.map(),
  ...PhotoReducer.map(),
  ...AuthorisationModalReducer.map(),
  ...CustomerReducer.map(),
  ...CustomerReviewFiltersReducer.map(),
  complianceMetadata,
  complianceModel,
  complianceRecords,
  complianceEvents,
  activeComplianceModule,
  complianceCustomerConfig,
  complianceAlertConfig,
  complianceAgeConfig,
  complianceCustomerInteractionConfig,
});

export default function baseReducer(state, action) {
  if (action.type === "CLEAR_REDUX") {
    state = appReducer({}, {});
  }

  return appReducer(state, action);
}
